export const sameThreadId = (left, right) =>
  left !== null &&
  left !== undefined &&
  right !== null &&
  right !== undefined &&
  String(left) === String(right);

export const getThreadDetailId = (threadDetail) =>
  threadDetail?.id ?? threadDetail?.thread_id ?? null;

export const threadHasMessage = (threadDetail, messageId) =>
  messageId !== null &&
  messageId !== undefined &&
  (threadDetail?.messages || []).some(
    (message) => String(message.message_id) === String(messageId),
  );

export const updateThreadDetailIfCurrent = (
  threadDetail,
  selectedThreadId,
  targetThreadId,
  update,
) => {
  if (!sameThreadId(selectedThreadId, targetThreadId)) return threadDetail;

  const detailId = getThreadDetailId(threadDetail);
  const isNewThread = targetThreadId === "new" && detailId === null;
  if (!isNewThread && !sameThreadId(detailId, targetThreadId)) {
    return threadDetail;
  }

  return update(threadDetail);
};

export const appendMessageToCurrentThread = (
  threadDetail,
  selectedThreadId,
  targetThreadId,
  message,
) =>
  updateThreadDetailIfCurrent(
    threadDetail,
    selectedThreadId,
    targetThreadId,
    (current) => {
      const messages = current?.messages || [];
      if (
        message.client_message_id &&
        messages.some(
          (item) => item.client_message_id === message.client_message_id,
        )
      ) {
        return current;
      }

      return { ...current, messages: [...messages, message] };
    },
  );

export const removeMessageFromCurrentThread = (
  threadDetail,
  selectedThreadId,
  targetThreadId,
  clientMessageId,
) =>
  updateThreadDetailIfCurrent(
    threadDetail,
    selectedThreadId,
    targetThreadId,
    (current) => ({
      ...current,
      messages: (current?.messages || []).filter(
        (message) => message.client_message_id !== clientMessageId,
      ),
    }),
  );
